import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '@/components/Dashboard/DashboardPendings/PendingsCard';
import RadioButtonsGroup from '@/components/Dashboard/RadioButtonsGroup';
import GenericBarChart from '../../../Charts/GenericBarChart';
import { setPropertiesTypes } from '@/store/slices/components/dashboard/DashboardSlice';
import {
  MAP_OPERATIONS,
  PROPERTY_OPERATIONS,
} from '@/components/Dashboard/constants';
import { getOverviewPropertiesTypes } from '@/store/slices/components/dashboard/service';
import useFetchDashboard from '@/components/Dashboard/customHooks/useFetchDashboard';
import {
  getHeaderUrl,
  getParsedLabels,
  handleClickBar,
  handleTooltip,
} from './utils';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import PropertyIcon from '@/public/images/dashboard/property.svg';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import { useTrackOverviewTab } from '@/components/Dashboard/customHooks/useTrackDashboard';

export default function PropertiesTypes() {
  const dispatch = useDispatch();
  const { overviewPropertiesTypes, miniCards } = useSelector(
    (state) => state.DashboardSlice
  );
  const track = useTrackOverviewTab();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  const { loading, hasFetched, labels, datasets, selectedOperation } =
    overviewPropertiesTypes;

  const operationId = MAP_OPERATIONS[selectedOperation];
  const { selectedStatusId: statusId, propertiesValue } = miniCards;

  useFetchOnViewport(
    (query) => {
      dispatch(getOverviewPropertiesTypes({ query, operationId, statusId }));
    },
    [statusId, operationId],
    { hasFetched }
  );

  const parsedLabels = getParsedLabels(labels, Trans(translations, 'Others'));
  const headerUrl = getHeaderUrl(operationId, statusId, selectedIds);

  const handleClickRadio = (operation) => {
    dispatch(
      setPropertiesTypes({
        key: 'selectedOperation',
        value: operation.id,
      })
    );
  };

  const allowedOptions = [
    { id: PROPERTY_OPERATIONS.SALE, text: Trans(translations, 'Sale') },
    { id: PROPERTY_OPERATIONS.RENT, text: Trans(translations, 'Rent') },
    {
      id: PROPERTY_OPERATIONS.TEMPORARY,
      text: Trans(translations, 'Temporary'),
    },
  ];

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={propertiesValue === 0 ? null : headerUrl}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.propertyType(element)}
      >
        {Trans(translations, 'PropertyType')}
      </PendingCard.Header>

      {propertiesValue === 0 ? (
        <DashboardEmptyStateCard
          icon={PropertyIcon}
          title={Trans(translations, 'HereYouWillSeeTheQuantityByPropertyType')}
        />
      ) : (
        <>
          <RadioButtonsGroup
            selectedOption={selectedOperation}
            onClickRadio={handleClickRadio}
            allowedOptions={allowedOptions}
          />
          <GenericBarChart
            labels={parsedLabels}
            datasets={datasets}
            onBarClick={
              selectedIds.length > 1
                ? null
                : ({ label }) =>
                    handleClickBar(
                      operationId,
                      label.typeId,
                      statusId,
                      selectedIds
                    )
            }
            getTooltipLabel={(context) => handleTooltip(context, labels)}
          />
        </>
      )}
    </PendingCard>
  );
}
